module.exports = __webpack_public_path__ + "media/images/front/brands/signature/signature_header_m-8eb719a7bc48ea78f2cdda20d47459dd.webp";